import { z } from "zod";

import { AnalyticsTool } from "@smart/bridge-types-basic";

export type SubmissionLink = {
  uri: string;
  formUri: string;
  teamUri: string;
  notifiedUserUris?: string[] | null;
  analyticsTools?: (AnalyticsTool & { __typename: "AnalyticsTool" })[] | null;
  userUri: string;
};

export type GenerateForm = {
  uri: string;
  values: {
    title: string;
    matterTypes: { id: string; category: string; location: string }[];
    category: "lead" | "matter";
  };
  slug?: { uri: string } | null;
};

export type Staff = {
  userId: string;
  firstName?: string;
  lastName?: string;
  email?: string;
};

export type LinkItemType = {
  formTitle: string;
  staff: string;
  link: SubmissionLink;
};

export const changeSettingsSchema = z.object({
  formName: z.string(),
  staff: z.string().array().min(1, "Please select a staff"),
});

export type ChangeSettingsForm = z.infer<typeof changeSettingsSchema>;
